const styles = {
  wrapper: {
    background: 'transparent',
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    width: 30,
    height: 60,
    label: {
      textAlign: 'left',
      width: '100%',
    },
  },
  inner: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  logo: {
    margin: 20,
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/HamburgerButton/styles.js